import { render, staticRenderFns } from "./LevelVar.vue?vue&type=template&id=832c959e&scoped=true&"
import script from "./LevelVar.vue?vue&type=script&lang=js&"
export * from "./LevelVar.vue?vue&type=script&lang=js&"
import style0 from "./LevelVar.vue?vue&type=style&index=0&id=832c959e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832c959e",
  null
  
)

export default component.exports